export default function PageSkeleton() {
  return (
    <div className="p-6">
      <div className="h-8 w-1/3 animate-pulse rounded bg-slate-200" />
      <div className="mt-4 h-4 w-2/3 animate-pulse rounded bg-slate-200" />
    </div>
  );
}
